import React from 'react';
import { notificationStore } from '../notification-store';
// @ts-ignore
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
// @ts-ignore
import { keyVault } from '@bingads-webui-react/popup-manager';
import { withStateStore } from '@bingads-webui/with-state-store';
import { INotification } from '../types';
import { FloatingBannerBar } from './floating-banner-bar';

interface IFloatingBannerProps {
  floatingBannerNotification?: INotification;
  i18n: any;
  clearNotification: () => void;
  Wrapper: React.ComponentClass<any>,
}

export class FloatingBanner extends React.PureComponent<IFloatingBannerProps> {
  private timeoutID: number = -1;

  render() {
    if (!this.props.floatingBannerNotification) {
      return null;
    } else {
      return (
        <FloatingBannerBar notification={this.props.floatingBannerNotification} i18n={this.props.i18n} Wrapper={this.props.Wrapper} dismiss={this.dismiss} />
      );
    }
  }

  componentDidMount() {
    if (this.props.floatingBannerNotification) {
      this.startDismiss();
    }
  }

  componentDidUpdate() {
    if (this.props.floatingBannerNotification) {
      this.startDismiss();
    }
  }

  dismiss = () => {
    if (this.timeoutID >= 0) {
      window.clearTimeout(this.timeoutID);
    }

    this.timeoutID = -1;
    this.props.clearNotification();
  };

  startDismiss() {
    if (this.timeoutID >= 0) {
      window.clearTimeout(this.timeoutID);
    }

    const autoDismissTime = this.props.floatingBannerNotification?.extraOptions?.autoDismissTime;
    if (autoDismissTime && autoDismissTime > 0) {
      this.timeoutID = window.setTimeout(() => {
        this.timeoutID = -1;
        this.props.clearNotification();
      }, autoDismissTime);
    }
  }
}

// floating banner is always action-triggered, so we use the store in shared repo to avoid creating two containers in app
export const getWrappedFloatingBannerContainer = (Wrapper?: React.ComponentClass<any>) => withStateStore(withI18nConsumer(FloatingBanner), notificationStore, (store: any) => {
  return {
    floatingBannerNotification: store.state.floatingBannerNotification,
    Wrapper,
    clearNotification: () => {
      store.setState({
        floatingBannerNotification: null
      });
    }
  };
});

export const WrappedFloatingBannerContainer = getWrappedFloatingBannerContainer();
